import { render, staticRenderFns } from "./VendorCreate.vue?vue&type=template&id=13c79bcd&scoped=true&"
import script from "./VendorCreate.vue?vue&type=script&lang=js&"
export * from "./VendorCreate.vue?vue&type=script&lang=js&"
import style0 from "./VendorCreate.vue?vue&type=style&index=0&id=13c79bcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c79bcd",
  null
  
)

export default component.exports